import Vue from 'vue'
const pluginName = '$filters'

const pluginValue = {
  commaFormat: (value) => {
    if (!value) return '0'
    const strNumber = value.toString().replace(/[^\d\\-]/g, '')
    const plainNumber = Number(strNumber).toString()
    return plainNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },
}

const plugin = {
  install(Vue) {
    Vue.prototype[pluginName] = pluginValue
  },
}

Vue.use(plugin)

export default plugin
